import { Component, Input } from '@angular/core';
import { PocketbaseService } from '../../services/pocketbase.service';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { timer, take } from 'rxjs';
import { checkPasswords } from '../auth';

@Component({
    selector: 'app-reset-password',
    imports: [CommonModule, ReactiveFormsModule],
    templateUrl: './reset-password.component.html',
    styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
  @Input()
  token: string | undefined;

  resetPasswordForm: FormGroup;
  success = false;

  constructor(
    private readonly pocketbaseService: PocketbaseService,
    private readonly fb: FormBuilder
  ) {
    this.resetPasswordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(8)]],
      passwordConfirm: ['', Validators.required]
    },
    { validators: checkPasswords }
  );
  }

  onSubmit() {
    if (!this.token) {
      throw new Error('password reset token not given')
    }
    if(this.resetPasswordForm.valid){
      const password = this.resetPasswordForm.get('password')?.value;
      const passwordConfirm = this.resetPasswordForm.get('passwordConfirm')?.value;

      this.pocketbaseService.pb.collection('users').confirmPasswordReset(this.token, password, passwordConfirm).then(() => {
        this.success = true;
  
        timer(2000).pipe(take(1)).subscribe(() => {
          // force user to use the new password, even if they were already logged in
          this.pocketbaseService.logout();
        });
      }).catch(() => {
        throw new Error('something went wrong')
      })
    }
  }
}
